const pathConfig = {
  iOS: {
    LiveDetail: 'LiveDetail', // 直播详情
    NewsDetail: 'NewsDetail'  // 新闻详情
  },
  Android: {
    LiveDetail: 'LiveDetail', // 直播详情
    NewsDetail: 'NewsDetail'  // 新闻详情
  },
  scheme: {
    jinrong: {
      iOS: 'iexhibitionjinrong://eastfair',
      Android: 'iexhibitionjinrongzhan://eastfair'
    },
    mianliao: {
      iOS: 'ivisitormianliao://eastfair',
      Android: 'ivisitormianliao://eastfair'
    }
  }
}
export default pathConfig